var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12 module-title" }, [_vm._v("LOGIN")]),
      _vm._v(" "),
      !_vm.firstLetter
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "name-description" }, [
              _vm._v("\n        Wat is je naam?\n      ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "letter-container" },
              _vm._l(_vm.letters, function(letter) {
                return _c(
                  "div",
                  {
                    staticClass: "letter-box",
                    on: {
                      click: function($event) {
                        _vm.selectFirstLetter(letter)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "letter-btn",
                        class: {
                          available: _vm.possibleLetters.indexOf(letter) !== -1
                        }
                      },
                      [
                        _c(
                          "table",
                          { staticStyle: { width: "100%", height: "100%" } },
                          [
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    "vertical-align": "middle"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(letter) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              })
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.firstLetter && !_vm.user
        ? _c(
            "div",
            { staticClass: "col-lg-12" },
            [
              _c("div", { staticClass: "name-description" }, [
                _vm._v("\n        Wat is je naam?\n      ")
              ]),
              _vm._v(" "),
              _vm._l(_vm.selectedUsers, function(user) {
                return _c(
                  "div",
                  {
                    staticClass: "user-username",
                    on: {
                      click: function($event) {
                        _vm.selectUser(user)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(user.firstName) +
                        " " +
                        _vm._s(user.lastName) +
                        "\n      "
                    )
                  ]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.user
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "user-username" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.user.firstName) +
                  " " +
                  _vm._s(_vm.user.lastName)
              ),
              _c("br")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-username" }, [
              _vm._v("\n        Toegangscode:"),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "code" }, [
                _c("div", {
                  staticClass: "code-box",
                  domProps: {
                    innerHTML: _vm._s(_vm.code.length > 0 ? "*" : "")
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "code-box",
                  domProps: {
                    innerHTML: _vm._s(_vm.code.length > 1 ? "*" : "")
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "code-box",
                  domProps: {
                    innerHTML: _vm._s(_vm.code.length > 2 ? "*" : "")
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "code-box",
                  domProps: {
                    innerHTML: _vm._s(_vm.code.length > 3 ? "*" : "")
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "code-box",
                  domProps: {
                    innerHTML: _vm._s(_vm.code.length > 4 ? "*" : "")
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "number-input-block" }, [
                _c(
                  "table",
                  {
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: { cellpadding: "1", cellspacing: "0" }
                  },
                  [
                    _c("tr", [
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("1")
                              }
                            }
                          },
                          [_vm._v("1")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("2")
                              }
                            }
                          },
                          [_vm._v("2")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("3")
                              }
                            }
                          },
                          [_vm._v("3")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("4")
                              }
                            }
                          },
                          [_vm._v("4")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("5")
                              }
                            }
                          },
                          [_vm._v("5")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("6")
                              }
                            }
                          },
                          [_vm._v("6")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("7")
                              }
                            }
                          },
                          [_vm._v("7")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("8")
                              }
                            }
                          },
                          [_vm._v("8")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("9")
                              }
                            }
                          },
                          [_vm._v("9")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td"),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.selectNumberCode("0")
                              }
                            }
                          },
                          [_vm._v("0")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "number-input-control" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                _vm.removeNumberCode()
                              }
                            }
                          },
                          [_vm._v("⇐")]
                        )
                      ])
                    ])
                  ]
                )
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a7153d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a7153d3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserAuthentication.vue
// module id = calG
// module chunks = 1